import React from 'react'
import { Accordion, AccordionProps } from '@wemolo/components'
import classNames from 'classnames'
import styles from './WemoloAccordion.module.css'

export type WemoloAccordionProps = AccordionProps

export const WemoloAccordion: React.FC<WemoloAccordionProps> = ({ className, ...rest }) => {
    return <Accordion {...rest} className={classNames(styles.root, className)} />
}
